import { Graph } from '@antv/x6';
import { registerCustomRouters } from '../utils/registerRouters';

/**
 * 注册结构性边类型：
 * - Aggregation-participation：源端为三角箭头
 * - Exhibition-characterization：三角内嵌三角（空心）
 * - Generalization-specialization：空心三角
 * - Classification-instantiation：三角内嵌圆
 *
 * 所有类型均使用下行出租车路由，并配合插槽偏移体系。
 */
export function registerStructuralEdges() {
  registerCustomRouters();
  // Aggregation-participation（空心三角，尖端在目标端 x=0）
  Graph.registerEdge(
    'opm-structural-aggregation',
    {
      inherit: 'edge',
      attrs: {
        line: {
          stroke: '#8c8c8c',
          strokeWidth: 1.5,
          targetMarker: {
            name: 'path',
            args: {
              d: 'M 0 8 L 14 0 L 14 16 Z',
              fill: 'none',
              stroke: '#8c8c8c',
              strokeWidth: 1.5,
            },
          },
        },
      },
      router: {
        name: 'orth',
        args: {
          padding: 20,
        },
      },
      connector: { name: 'jumpover', args: { size: 5 } },
    },
    true,
  );

  // Exhibition-characterization（嵌套三角，尖端在目标端 x=0）
  Graph.registerEdge(
    'opm-structural-exhibition',
    {
      inherit: 'edge',
      attrs: {
        line: {
          stroke: '#8c8c8c',
          strokeWidth: 1.5,
          targetMarker: {
            name: 'path',
            args: {
              d: 'M 0 8 L 14 0 L 14 16 Z M 4 8 L 12 4 L 12 12 Z',
              fill: 'none',
              stroke: '#8c8c8c',
              strokeWidth: 1.5,
            },
          },
        },
      },
      router: {
        name: 'orth',
        args: {
          padding: 20,
        },
      },
      connector: { name: 'jumpover', args: { size: 5 } },
    },
    true,
  );

  // Generalization-specialization（空心三角，尖端在目标端 x=0）
  Graph.registerEdge(
    'opm-structural-generalization',
    {
      inherit: 'edge',
      attrs: {
        line: {
          stroke: '#8c8c8c',
          strokeWidth: 1.5,
          targetMarker: {
            name: 'path',
            args: {
              d: 'M 0 8 L 14 0 L 14 16 Z',
              fill: 'none',
              stroke: '#8c8c8c',
              strokeWidth: 1.5,
            },
          },
        },
      },
      router: {
        name: 'orth',
        args: {
          padding: 20,
        },
      },
      connector: { name: 'jumpover', args: { size: 5 } },
    },
    true,
  );

  // Classification-instantiation（空心三角，尖端在目标端 x=0）
  Graph.registerEdge(
    'opm-structural-classification',
    {
      inherit: 'edge',
      attrs: {
        line: {
          stroke: '#8c8c8c',
          strokeWidth: 1.5,
          targetMarker: {
            name: 'path',
            args: {
              d: 'M 0 8 L 14 0 L 14 16 Z',
              fill: 'none',
              stroke: '#8c8c8c',
              strokeWidth: 1.5,
            },
          },
        },
      },
      router: {
        name: 'orth',
        args: {
          padding: 20,
        },
      },
      connector: { name: 'jumpover', args: { size: 5 } },
    },
    true,
  );
}

/**
 * 辅助函数：根据结构性子类型获取对应的边形状名称
 */
export function getStructuralEdgeShape(subtype?: string): string {
  switch (subtype) {
    case 'aggregation-participation':
      return 'opm-structural-aggregation';
    case 'exhibition-characterization':
      return 'opm-structural-exhibition';
    case 'generalization-specialization':
      return 'opm-structural-generalization';
    case 'classification-instantiation':
      return 'opm-structural-classification';
    default:
      return 'opm-structural-aggregation';
  }
}
